namespace TabAurous.Inventory {
    export namespace StockAllocatedItemsService {
        export const baseUrl = 'StockAllocation/StockAllocatedItems';

        export declare function Create(request: Serenity.SaveRequest<StockAllocatedItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<StockAllocatedItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<StockAllocatedItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<StockAllocatedItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "StockAllocation/StockAllocatedItems/Create",
            Update = "StockAllocation/StockAllocatedItems/Update",
            Delete = "StockAllocation/StockAllocatedItems/Delete",
            Retrieve = "StockAllocation/StockAllocatedItems/Retrieve",
            List = "StockAllocation/StockAllocatedItems/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>StockAllocatedItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
